import React from 'react'

const Why = () => (
    <h2>Why</h2>
)

export default Why;